export default "__VITE_ASSET__BnkAy4RP__"